<script>
import {
  infoComplementairesEmits,
  infoComplementairesProps,
  useInfoComplementaires
} from "./mixin";

import Form from "@/components/molecules/form";
import FormGroup from "@/components/molecules/form-group";
import FormCheckbox from "@/components/molecules/form-checkbox";
import FormInput from "@/components/molecules/form-input";
import Button from "@/components/atoms/button";
import Container from "@/components/atoms/container";
import StickyFooter from "@/components/molecules/sticky-footer";
import LinkTo from "@/components/atoms/link-to";

export default {
  name: "ShippingMethodLadInfosComplementaires",
  components: {
    Form,
    FormGroup,
    FormInput,
    FormCheckbox,
    Button,
    Container,
    StickyFooter,
    LinkTo
  },
  props: { ...infoComplementairesProps() },
  emits: [...infoComplementairesEmits()],
  setup(props, context) {
    const {
      getState,
      getErrorMessage,
      forceUpdate,
      newAddresseLad,
      v$,
      infosLegalesFormatted,
      change,
      validate
    } = useInfoComplementaires(props, context);

    return {
      getState,
      getErrorMessage,
      forceUpdate,
      newAddresseLad,
      v$,
      infosLegalesFormatted,
      change,
      validate
    };
  }
};
</script>

<template>
  <div>
    <Container>
      <div class="c-shipping-address-mobile__title">
        <strong>
          Informations complémentaires
        </strong>
      </div>

      <Form>
        <FormGroup :state="getState(v$,'tel', 'newAddresseLad')">
          <FormInput
            :key="forceUpdate"
            v-model="newAddresseLad.tel"
            class="c-shipping-address__input u-mt-sm"
            :state="getState(v$,'tel', 'newAddresseLad')"
            aria-describedby="telRdv"
            @blur="v$.newAddresseLad.tel.$touch()"
            @input="
              v$.newAddresseLad.tel.$reset();
              change();
            "
          >
            Numéro pour la prise de rendez-vous*
          </FormInput>
          <template #message>
            <div id="telRdv">
              <p v-if="v$.newAddresseLad.tel.required.$invalid">
                Merci de confirmer votre numéro de téléphone
              </p>
              <p v-else-if="v$.newAddresseLad.tel.tel.$invalid">
                Ce numéro de téléphone n'est pas un numéro de téléphone valide.
              </p>
              <p v-else>
                {{ getErrorMessage("tel","Ce numéro de téléphone est invalide.") }}
              </p>
            </div>
          </template>
        </FormGroup>

        <FormGroup :state="getState(v$,'info_livreur', 'newAddresseLad')">
          <FormInput
            :key="forceUpdate"
            v-model="newAddresseLad.info_livreur"
            :state="getState(v$,'info_livreur', 'newAddresseLad')"
            type="textarea"
            class="c-shipping-address__input u-mt-md"
            aria-describedby="infosLivreur"
            @blur="v$.newAddresseLad.info_livreur.$touch()"
            @input="
              v$.newAddresseLad.info_livreur.$reset();
              change();
            "
          >
            Informations pour le livreur
          </FormInput>
          <template #message>
            <div id="infosLivreur">
              <p>
                {{ getErrorMessage("info_livreur","Le format est invalide") }}
              </p>
            </div>
          </template>
        </FormGroup>

        <p class="c-shipping-address-mobile__required-field u-mt-sm">
          * champs obligatoires
        </p>

        <p class="u-font-15 u-mt-md">
          Merci de préciser les conditions d'accès à votre domicile
        </p>

        <div class="u-mt-sm">
          <FormGroup
            inline
            size="full"
          >
            <div class="c-shipping-address-mobile__checkbox-wrapper">
              <FormCheckbox
                v-model="newAddresseLad.centre_ville"
                class="c-shipping-address-mobile__access-checkbox"
                @change="change"
              >
                <span class="u-font-15">Centre ville</span>
              </FormCheckbox>

              <FormCheckbox
                v-model="newAddresseLad.voie_sans_issue"
                class="c-shipping-address-mobile__access-checkbox"
                @change="change"
              >
                <span class="u-font-15">Voie sans issue</span>
              </FormCheckbox>

              <FormCheckbox
                v-model="newAddresseLad.sens_unique"
                class="c-shipping-address-mobile__access-checkbox"
                @change="change"
              >
                <span class="u-font-15">Sens unique</span>
              </FormCheckbox>

              <FormCheckbox
                v-model="newAddresseLad.rue_pietonne"
                class="c-shipping-address-mobile__access-checkbox"
                @change="change"
              >
                <span class="u-font-15">Rue piétonne</span>
              </FormCheckbox>

              <FormCheckbox
                v-model="newAddresseLad.access_semi_remorque"
                class="c-shipping-address-mobile__access-checkbox"
                @change="change"
              >
                <span class="u-font-15">Accès semi-remorque</span>
              </FormCheckbox>

              <FormCheckbox
                v-model="newAddresseLad.residence"
                class="c-shipping-address-mobile__access-checkbox"
                @change="change"
              >
                <span class="u-font-15">Résidence</span>
              </FormCheckbox>
            </div>
          </FormGroup>
        </div>
      </Form>
      <p class="u-font-12 u-color-grey-2 u-mt-md u-pb-md">
        Les données recueillies dans ce formulaire font l'objet d'un traitement par la société Cora, en tant que responsable de traitement, pour les finalités suivantes :
      <ul>
        <li>Création et gestion du Compte Client Internet</li>
        <li>Gestion des commandes, réservations et paiements des produits et services sur les sites internet et applications de Cora</li>
        <li>Adhésion au programme de fidélité via internet dans le cadre de l'activation de la carte malin</li>
        <li>Traitement des questions ou réclamations concernant notamment le programme de fidélité, le compte client internet, les produits, les services, les sites et applications de Cora</li>
        <li>Envoi d'informations non commerciales en raison de votre adhésion au programme de fidélité ou de l'existence d'un Compte Client Internet</li>
        <li>Gestion d'un éventuel rappel de produit auprès du consommateur</li>
        <li>Lutte contre la fraude au programme de fidélité et à l'existence du compte client internet</li>
        <li>Élaboration de statistiques, études ou analyses commerciales ou techniques dans le but d'améliorer nos sites, nos applications, notre programme de fidélité, notre connaissance du client, des produits ou services que nous vous proposons ou la fourniture d'informations sur les produits et services de Cora</li>
        <li>Suivi des achats via l'édition des factures, tickets de caisses et autres documents</li>
        <li>Amélioration de l'utilisation et du fonctionnement du site et des services de Cora</li>
        <li>Préparation ou exercice d'un recours en justice ou devant une administration et, le cas échéant, exécution de la décision rendue</li>
        <li>Gestion des consentements et des autorisations sur l'utilisation des données personnelles</li>
        <li>Exercice des droits sur les données personnelles</li>
        <li>Sur demande, l'obtention d'un devis pour un service ou un produit</li>
        <li>Sur demande du client, l'information par SMS sur le statut de vos commandes</li>
      </ul>
      <br />
      Conformément au <strong>Règlement (UE) 2016/679 relatif à la protection des données à caractère personnel</strong>, vous disposez, en fonction du fondement juridique du traitement, des droits suivants sur vos données : droit d'accès, droit de rectification, droit à l'effacement (droit à l'oubli), droit d'opposition, droit à la limitation du traitement et droit à la portabilité. <br /><br />
      Vous pouvez également définir les directives relatives à la conservation, à l'effacement et à la communication de vos données à caractère personnel après votre décès.<br /><br />
      Pour plus de renseignements, veuillez consulter la
      <LinkTo
        href="https://www.cora.fr/legal/informations-juridiques/politique-donnees-personnelles-clients-internet"
        target="__blank"
      >
        Politique Données Personnelles Clients Internet
      </LinkTo>
      de Cora.
      </p>
      <p
        v-if="infosLegalesFormatted"
        class="u-font-12 u-color-grey-2 u-pb-lg u-pt-md"
      >
        {{ infosLegalesFormatted }}
      </p>
    </Container>
    <StickyFooter class="u-text-center ">
      <Button
        radius="full"
        variant="secondary"
        size="md"
        @click="validate"
      >
        Je valide cette adresse
      </Button>
    </StickyFooter>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-address-mobile.scss";
</style>
